export default {
  appTitle: 'RCM',
  rcmGrid: {
    invoiceNumber: 'Invoice No.',
    healthcarePlanCoverage: 'PBS',
    patientId:'Patient ID',
    eventNumber: 'Event',
    eventDate: 'Event date',
    payerName: 'Payer',
		agreementName: 'Agreement',
    invoiceAmount: 'Account Value ({currency})',
    suffix: '$',
    requiredSupportDocumentsCompleted: 'Documentation',
    agreementCode: 'Convention ID',
    status: 'Status',
    serviceTypes: 'Event type',
    regime: 'Regime',
    responsible: 'Responsible',
    costCenter: 'Cost Center',
    settlementGroupId: 'Delivery Relationship',
  },
  rcmGridItems: {
    defaultStatus: {
      pending: 'PENDING'
    }
  },
  rcmGridTooltips: {
    multiples: 'Multiple',
    reassignedAccount: 'Rebilled account'
  },
  documentationStatus: {
    complete: 'Complete',
    incomplete: 'Incomplete',
    ripAndCuvFilesIncomplete: 'RIP and CUV files incomplete',
  },
  filters: {
    searchCode: 'Search by invoice no., event, agreement id, regime or patient id',
    invoiceNumberStatus: 'Status',
    statusHealthcarePlanCoverage: 'Healthcare Plan',
    statusDocumentation: 'Documentation Status',
    payer: 'Payer',
		agreement: 'Agreement',
    minAmount: 'Min. Amount',
    maxAmount: 'Max. Amount',
    from: 'From',
    to: 'To',
    concurrent: 'Concurrent',
    serviceType: 'Event type',
    seeMoreFilters: 'See more filters',
    executorServices: 'Specialty',
    agreementPlanTypes: 'Plan type',
    invoiceSource: 'Invoice source',
    applyFilters: 'Apply filters',
    currency: 'USD',
    missingSupports: 'Missing documents',
    noResultsFound: 'No results found',
    responsibleAssigned: 'Responsible assigned',
    reassignedAccount: 'Re-invoicing',
  },
  resultLabel: {
    text: 'Results',
    result: '({result})'
  },
  actionLabel: {
    text: 'Actions',
    selected: '({selected})'
  },
  accountsActions: {
    moveToReadyToSettlement: 'Move to ready to settlement',
    moveToSent: 'Move to sent',
    moveToSettled: 'Move to settled',
    disableAccounts: 'Disable accounts',
    assignResponsible: 'Assign responsible',
    cleanPackageFolder: 'Delete FileZilla folder',
  },
  homeConfirmationDialog: {
    disableAccounts: {
      title: "Are you sure you want to disable the selected accounts?",
      subtitle: "Add a reason for disabling the accounts (optional)",
    },
    moveToSettled: {
      title: "Are you sure you want to move to settled the selected accounts?",
      subtitle: "",
    },
    moveToSent: {
      title: "Are you sure you want to move to sent the selected accounts?",
      subtitle: ""
    },
    moveToPackageGenerated: {
      title: "Are you sure you want to move to ready to settlement the selected accounts?",
      subtitle: ""
    },
    assignResponsible: {
      title: "Assign responsible",
      subtitle: "Select the responsible for the selected accounts",
      label: "Responsible",
    },
    cleanPackageFolder: {
      title: "Are you sure you want to delete FileZilla folder?",
      subtitle: "",
    },
  },

  filtersText: {
    statusAccounts: {
      inProgress: 'In progress',
      invoiced: 'Invoiced',
      readyToGenerate: 'Ready to generate',
      packageGenerated: 'Ready to settlement',
      pendingAudit: 'Pending audit',
      voided: 'Voided',
      error: 'Error',
      completeAudit: 'Complete audit',
      sent: 'Sent',
      settled: 'Settled',
      preInvoiced: 'Pre-invoiced'
    },
    statusHealthcarePlanCoverage: {
      pos: 'PBS',
      notPos: 'NPBS',
      posNoPos: 'PBS / NPBS'
    },
    statusDocumentation: {
      completed: 'Complete',
      incomplete: 'Incomplete'
    },
    statusPayers: {
      nuevaEps: 'Nueva EPS'
    },
    reassignedAccount: {
      reassigned: 'Rebilled accounts'
    },
    statusConcurrent: 'Concurrent account',
    mobileHeader: 'Filters'
  },
  drawer: {
    labels: {
      accounts: 'Accounts',
      agreements: 'Agreements',
      preSettlement: 'Delivery relationship',
      pmisConfig: 'PMIS Configuration',
      uploadAgreement: 'Upload agreements'
    },
    addOns: {
      accounts: {
        title: 'Accounts List',
        placeholder: 'Search by ID',
        createdAt: 'Creation Date',
        stateAccount: 'Status',
        invoiceNumber: 'Invoice No.',
        healthcarePlanCoverage: 'PBS / NPBS',
        totalInvoiceAmount: 'Invoice No.',
        agreement: 'Agreement',
        locationName: 'Location'
      }
    }
  },
  accountDetail: {
    generalInformation: {
      titlesGeneralInformation: {
        patientName: 'Patient',
        patientId: 'Patient ID',
        patientDocumentType: 'Identification type',
        patientDocumentNumber: 'Identification No.',
        eventNumber: 'Event',
        eventDate: 'Event date',
        serviceType: 'Event type',
        insurer: 'Agreement',
        originInvoiceGroupId: 'Delivery Relationship',
        settlementNumber: 'Settlement ID',
        externalId: 'External ID',
        authorizationId: 'Authorization ID',
        regime: 'Regime',
        agreementPlanType: 'Plan type',
        invoiceSource: 'Invoice source',
        invoiceNumber: 'Invoice No.',
        invoiceDate: 'Invoice date',
        invoiceBranch: 'Invoice branch',
        createdAt: 'Account creation Date',
        stateAccount: 'Status',
        agreement: 'Agreement code',
        healthcarePlanCoverage: 'PBS / NPBS',
        invoiceAmountTotal: 'Total Amount',
        responsible: 'Responsible',
        reassignedInvoiceNumber: 'Reinvoiced source account',
      },
      defaultInformation: {
        defaultRegime: 'EPS',
        defaultInvoiceAmount: 'Pending',
        defaultHealthCarePlanCoverage: 'PBS / NPBS'
      }
    }
  },
  chargeDetail: {
    patientInformation: {
      patientName: 'Patient',
      patientId: 'Patient ID',
      eventNumber: 'Event',
      patientDocumentType: 'Identification type',
      patientDocumentNumber: 'Identification No.'
    },
    chargeDetail: {
      createdAt: 'Creation Date',
      healthcarePlanCoverage: 'PBS / NPBS',
      chargeCode: 'Charge Code',
      authorizationId: 'Agreement number',
      invoiceable: 'Invoicable',
      payer: 'Insurer',
      location: 'Location',
      typeOfService: 'Service Type',
      quantity: 'Quantity',
      invoiceNumber: 'Invoice No.',
      unitValue: 'Unit Value',
      totalAmount: 'Total Amount'
    },
    defaultInformation: {
      defaultInvoiceAmount: 'Pending',
    },
    diagnosticTable: {
      diagnosticCode: 'Diagnostic Code',
      descriptionDiagnosis: 'Diagnostic Description',
      chargeDescription: 'Charge Description'
    }
  },
  amounts: {
    ruleMessage: 'Only positive numbers allowed',
    minAmount: 'Min. {currency} {amount}',
    maxAmount: 'Max. {currency} {amount}',
  },
  auditComplete: 'The account has been audited successfully',
  setReadyToGenerate: 'The account has been set to Ready to Generate',
  setReadyToGenerateMultiple: 'Invoice account has been set as ready to generate. This process may take a few minutes; please wait. | Invoice accounts have been set as ready to generate. This process may take a few minutes; please wait.',
  setPreSettlementActionMultiple: 'Invoice account have been queued for processing. This process may take a few minutes; please wait. | Invoice accounts have been queued for processing. This process may take a few minutes; please wait.',
  setPreSettlementRipsValidationErrors: 'The delivery relationship has been marked with the RIPS file validation error status.',
  setDisableAccounts: 'The accounts have been disabled successfully',
  movedToSettlement: 'Accounts have been queued for processing. This process may take a few minutes; please wait.',
  assignResponsible: 'The responsible has been assigned successfully',
  accountsAffected: 'Accounts affected',
  lastUpdate: 'Last updated',
  errorLoadindServiceTypes: 'Error getting provider service types.',
	errorLoadindAgreements: 'Error getting provider agreements.',
  errorLoadindProviderSupportDocuments: 'Error getting provider support documents.',
  errorLoadindUsers: 'Error getting users.',
  cleanPackageFolder: "The account FileZilla folder has been deleted successfully",
	validateAccountNotifications: {
		filter: 'Revalidate accounts',
		inProgressWording: 'selected accounts',
		completedWording: 'accounts',
		errorWording: 'accounts, please try again. ',
		status: {
			started: 'Started',
			inProgress: 'In progress',
			completed: 'Completed',
			error: 'Error'
		}
	}
}
